import React from 'react';
import { StyledHistoryDetailInfo } from './styles';

interface Props {
  date: string;
  user: string;
  times: string;
}

const HistoryDetailInfo = ({ date, user, times }: Props) => {
  // 라이센스 텍스트 반환
  const makeText = (text: string) => {
    return text === 'UNLIMITED' ? 'Unlimited' : text;
  };

  return (
    <StyledHistoryDetailInfo>
      <ul>
        <li>
          <strong>Expiration Date</strong>
          <span>{makeText(date)}</span>
        </li>
        <li>
          <strong>Number of User</strong>
          <span>{makeText(user)}</span>
        </li>
        <li>
          <strong>Number of Times</strong>
          <span>{makeText(times)}</span>
        </li>
      </ul>
    </StyledHistoryDetailInfo>
  );
};

export default HistoryDetailInfo;
